(() => {
  const ROOT_SELECTOR = '[data-hgb-video-hero]';

  const getVisibleVideos = (root) =>
    Array.from(root.querySelectorAll('video')).filter((video) => video.offsetParent !== null);

  const updateButton = (button, paused) => {
    if (!button) return;
    button.dataset.paused = paused ? 'true' : 'false';
    button.setAttribute('aria-label', paused ? 'Reproducir video' : 'Pausar video');
  };

  const initializeHero = (root) => {
    if (!root || root.dataset.hgbVideoReady === 'true') return;
    root.dataset.hgbVideoReady = 'true';

    const button = root.querySelector('[data-hgb-video-toggle]');
    if (!button) return;

    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    const pauseAll = () => {
      root.querySelectorAll('video').forEach((video) => video.pause());
      updateButton(button, true);
    };

    const playVisible = () => {
      const videos = getVisibleVideos(root);
      videos.forEach((video) => {
        const result = video.play();
        if (result && typeof result.catch === 'function') result.catch(() => {});
      });
      updateButton(button, false);
    };

    if (reduceMotion.matches) {
      pauseAll();
    } else {
      playVisible();
    }

    button.addEventListener('click', () => {
      const videos = getVisibleVideos(root);
      const isPlaying = videos.some((video) => !video.paused && !video.ended);
      if (isPlaying) pauseAll();
      else playVisible();
    });

    reduceMotion.addEventListener?.('change', (event) => {
      if (event.matches) pauseAll();
      else playVisible();
    });
  };

  const initializeAll = (scope = document) => {
    scope.querySelectorAll(ROOT_SELECTOR).forEach(initializeHero);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll(), { once: true });
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
